import React, { useEffect, useReducer, useState } from "react";
import {
  Alert,
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  Label,
  FormText,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Media
} from "reactstrap";
import { MDBIcon } from "mdbreact";
import "assets/custom/custom.css";
import moment from "moment";
import axios from "utils/api";
import DualListBox from 'react-dual-listbox';

const imageHeader = {
  borderRadius: '40px'
};

const loginHeader = {
  fontWeight: 500,
  fontSize: '20px'
};

const characterSettings = {
  fontWeight: 500,
  color: 'black'
};

const changePassword = {
  paddingBottom: "0px",
  textAlign: "center",
  marginLeft: "50px",
  marginTop: "-10px"
};




const UserDetails = props => {
  const authSession = JSON.parse(localStorage.getItem('auth'));
  const [user, setUser] = useState({
    accessDevice: false,
    accessPortal: false,
    dateCreated: 'n/a',
    dateModified: moment().format('DD/MM/YYYY HH:mm:ss'),
    emailAddress: '',
    lastLoginDate: 'n/a',
    lastPasswordChange: 'n/a',
    merchantGroupId: null,
    mobileNumber: '',
    password: '',
    portalUserId: null,
    status: 1,
    username: ''
  });

  const [formState, setFormState] = useState({
    values: { newPassword: '', confirmPassword: '' },
    showNewPassword: false,
    showConfirmPassword: false,
    errorColor: '',
    errorMessage: '',
    errorColorModal: '',
    errorMessageModal: ''
  });

  const userId = window.location.pathname.split('/')[3];

  const [statusText, setStatusText] = useState('Active');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [openAlertModal, setOpenAlertModal] = useState(false);
  const [addMode, setAddMode] = useState(false);
  const [settings, setSettings] = useState([]);
  const [passwordHistory, setPasswordHistory] = useState([]);
  const [isValidMobile, setIsValidMobile] = useState(true);
  const [isValidEmailAddress, setIsValidEmailAddress] = useState(true);
  const [access, setAccess] = useState('portal');
  const toggle = () => setDropdownOpen(prevState => !prevState);

  const [modalPass, setModalPass] = useState(false);
  const toggleModal = () => setModalPass(!modalPass);

  //duallistbox
  // const [state, setselect] = useState();
  const [midProfiles, setMIDProfiles] = useState([]);
  const [SelectedList, setSelectedList] = useState([])
  const [InitalSelectedList, setinitialSelectedList] = useState([])

  const minPasswordLength = 8;
  const minSpecialCharacters = 2;
  const enforcePasswordHistory = 1;


  useEffect(() => {
    let mounted = true;
    getMIDProfiles();
    if (mounted) {
      if (!window.location.href.includes('user/add')) {
        getUser(userId);

        console.log('test 1');

      } else {
        console.log('test 2');
      }
    }

    return () => {
      mounted = false;
    };
  }, []);

  const handleShowPassword = (event) => {
    if (event === 'newPassword')
      setFormState({ ...formState, showNewPassword: !formState.showNewPassword });
    else
      setFormState({ ...formState, showConfirmPassword: !formState.showConfirmPassword });
  };

  const redAsterisk = () => {
    return (
      <label style={{ color: 'red' }}>
        *
      </label>
    );
  }


  const passwordValidation = () => {
    return (
      <div className="text-muted">
        <small>New Password must:</small><br />
        <small style={{ textDecoration: (formState.values.newPassword === formState.values.confirmPassword && formState.values.newPassword !== "") ? "line-through" : "none" }}>- Match with the password confirmation.</small><br />
        <small style={{ textDecoration: (specialCharCount >= parseInt(minSpecialCharacters)) ? "line-through" : "none" }}>- Contain atleast <span style={characterSettings}>({minSpecialCharacters})</span> special character(s).</small><br />
        <small style={{ textDecoration: (formState.values.newPassword.trim().length >= parseInt(minPasswordLength)) ? "line-through" : "none" }}>- Contain atleast <span style={characterSettings}>({minPasswordLength})</span> character(s) long.</small>
      </div>
    );
  };

  const getUser = (userId) => {
    axios.get(`/user/getbyid?id=${userId}`)
      .then(response => {
        const userDetails = response.data.user[0];

        console.log(userDetails);

        setUser({
          portalUserId: userDetails.portalUserId,
          merchantGroupId: userDetails.merchantGroupId,
          username: userDetails.username,
          emailAddress: userDetails.emailAddress,
          mobileNumber: userDetails.mobileNumber,
          accessPortal: userDetails.accessPortal,
          accessDevice: userDetails.accessDevice,
          status: userDetails.status,
          password: userDetails.password,
          dateCreated: userDetails.dateCreated !== null ? moment(response.data.user[0].dateCreated).format('YYYY-MM-DD hh:mm A') : moment(),
          dateModified: userDetails.dateModified !== null ? moment(response.data.user[0].dateModified).format('YYYY-MM-DD hh:mm A') : moment(),
          lastLoginDate: userDetails.lastLoginDate !== null ? moment(response.data.user[0].lastLoginDate).format('YYYY-MM-DD hh:mm A') : 'n/a',
          lastPasswordChange: userDetails.lastPasswordChange !== null ? moment(response.data.user[0].lastPasswordChange).format('YYYY-MM-DD hh:mm A') : 'n/a'
        });

        getMidSelected(userDetails.portalUserId);
        getUserAccess(userDetails.accessPortal, userDetails.accessDevice);
        getSettings(userDetails.portalUserId, userDetails.merchantGroupId);

        validateMobileFormat(userDetails.mobileNumber);
        validateEmailAddress(userDetails.emailAddress);
      }).catch(() => {
        setFormState(formState => ({
          ...formState,
          errorColor: 'danger',
          errorMessage: 'There is a problem fetching user details. Please try again later.'
        }));

        setOpenAlert(true);

        window.scrollTo({ top: 0, behavior: 'smooth' });
      });


  };

  const getSettings = (portalUserId, merchantGroupId) => {
    // axios.get('settings/getbyid/?id=1')
    //   .then(response => {
    //     setSettings(response.data.settings);

    //     if (!window.location.href.includes('user/add')) {
    //       axios.get(`user/getpasswordhistory/?portalUserId=${portalUserId}&merchantGroupId=${merchantGroupId}&passwordhistory=${response.data.enforcePasswordHistory}`)
    //         .then(pHistory => {
    //           setPasswordHistory(pHistory.data.history)
    //         });
    //     }
    //   }).catch(() => {
    //     setSettings([]);
    //   });
  }

  const getUserAccess = (accessPortal, accessDevice) => {
    if (accessPortal && accessDevice)
      setAccess('both');
    else if (accessPortal)
      setAccess('portal');
    else if (accessDevice)
      setAccess('device');
  }


  const handleAlertClose = () => {
    setOpenAlert(false);
    setOpenAlertModal(false);
  };

  const handleChangePasswordClick = (event) => {
    setModalPass(!modalPass);
  };

  const handleStatusClick = (event) => {
    if (event.value === 1) {
      setStatusText('Active');
    }
    else {
      setStatusText('Inactive');
    }

    setUser(User => ({
      ...User, status: event.value
    }));
  };

  const handleChange = (event, value, param) => {
    event.persist();

    if (param === 'mobileNumber') {
      validateMobileFormat(value);
    }

    if (param === 'emailAddress') {
      validateEmailAddress(value);
    }

    if (param === 'access') {
      setAccess(value);
    }

    setUser(User => ({
      ...User, [param]: value
    }));
  };

  const handlePasswordChange = (event, value, param) => {
    event.persist();

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [param]: value
      },
      touched: {
        ...formState.touched,
        [param]: true
      }
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (isValidMobile) {
      if (isValidEmailAddress) {
        if (access === 'device') {
          user.accessDevice = true;
          user.accessPortal = false;
        } else if (access === 'portal') {
          user.accessPortal = true;
          user.accessDevice = false;
        } else {
          user.accessPortal = true;
          user.accessDevice = true;
        }

        if (!window.location.href.includes('user/add')) {
          axios.post('/user/update', {
            user: {
              portalUserID: user.portalUserId,
              merchantGroupId: user.merchantGroupId,
              username: user.username,
              emailAddress: user.emailAddress,
              mobileNumber: user.mobileNumber,
              allowPortalAccess: user.accessPortal,
              allowDeviceAccess: user.accessDevice,
              status: parseInt(user.status)
            },
            MIDSeLected: SelectedList
          })
            .then((response) => {
              setFormState(formState => ({
                ...formState,
                errorColor: 'success',
                errorMessage: 'User details was successfully updated.'
              }));

              var auditlog = {
                moduleName: `User Details`,
                accountId: authSession?.merchantGroupCode,
                username: authSession?.username,
                actionsTaken: `Updated the user details of ${response.data.username}`
              };

              axios.post('auditlog/add', { auditlog: auditlog }).then(() => { });

              setTimeout(function () {
                window.location.reload();
              }, 3000);

              setOpenAlert(true);

              window.scrollTo({ top: 0, behavior: 'smooth' });
            })
            .catch(() => {
              setFormState(formState => ({
                ...formState,
                errorColor: 'danger',
                errorMessage: 'There is a problem updating the user details. Please try again later.'
              }));

              setOpenAlert(true);

              window.scrollTo({ top: 0, behavior: 'smooth' });
            });
        } else {
          axios.post('/user/add', {
            user: {
              merchantGroupId: parseInt(authSession?.merchantGroupId),
              username: user.username,
              password: user.password,
              emailAddress: user.emailAddress,
              mobileNumber: user.mobileNumber,
              allowPortalAccess: user.accessPortal,
              allowDeviceAccess: user.accessDevice,
              signOnAttempts: parseInt(user.signOnAttempts),
              status: parseInt(user.status)
            },
            MIDSeLected: SelectedList

          })
            .then((response) => {
              setFormState(formState => ({
                ...formState,
                errorColor: 'success',
                errorMessage: 'User was successfully created.'
              }));

              setTimeout(function () {

                window.location.replace(`/admin/user/${response.data.portalUserID}`);

              }, 2000);

              setOpenAlert(true);

              window.scrollTo({ top: 0, behavior: 'smooth' });
            })
            .catch(() => {
              setFormState(formState => ({
                ...formState,
                errorColor: 'danger',
                errorMessage: 'There is a problem creating the sub-user. Please try again later.'
              }));

              setOpenAlert(true);

              window.scrollTo({ top: 0, behavior: 'smooth' });
            });
        }
      } else {
        setFormState(formState => ({
          ...formState,
          errorColor: 'danger',
          errorMessage: `Email address is invalid. Please follow the correct format.`
        }));

        setOpenAlert(true);

        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    } else {
      setFormState(formState => ({
        ...formState,
        errorColor: 'danger',
        errorMessage: `Mobile number is invalid. Please follow the correct format.`
      }));

      setOpenAlert(true);

      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleSubmitPassword = () => {
    var users = {
      portalUserId: parseInt(user.portalUserId),
      merchantGroupCode: authSession?.merchantGroupCode,
      username: user.username,
      password: formState.values.newPassword,
      merchantGroupId: user.merchantGroupId,
      passwordHistory: enforcePasswordHistory
    };

    if (formState.values.newPassword.trim().length > 0 && formState.values.confirmPassword.trim().length > 0) {
      if (user.status === 1) {
        axios.post('user/changepassword', { user: users })
          .then((response) => {
            if (response.status === 200) {
              setFormState(formState => ({
                ...formState,
                errorColorModal: 'success',
                errorMessageModal: 'Your password has been successfully changed.'
              }));

              setTimeout(function () {
                toggleModal();
                window.location.reload();
              }, 3000);
            } else {
              setFormState(formState => ({
                ...formState,
                errorColorModal: 'danger',
                errorMessageModal: `The new password must not match with the (${enforcePasswordHistory}) previous password(s) history.`
              }));
            }
          }).catch((error => {
            setFormState(formState => ({
              ...formState,
              errorColorModal: 'danger',
              errorMessageModal: 'There is a problem changing your new password. Please try again later.'
            }));
          }));

        setOpenAlertModal(true);
      } else {
        setFormState(formState => ({
          ...formState,
          errorColorModal: 'danger',
          errorMessageModal: 'The user is currently inactive. Please change the status to proceed changing the password.'
        }));

        setOpenAlertModal(true);
      }
    } else {
      setFormState(formState => ({
        ...formState,
        errorColorModal: 'danger',
        errorMessageModal: 'Please fill out the required field(s) below.'
      }));

      setOpenAlertModal(true);
    }
  }

  const validateMobileFormat = (mobileNumber) => {
    if (mobileNumber.match(/^(09|\+639)\d{9}$/)) {
      setIsValidMobile(true);

      return true;
    } else {
      setIsValidMobile(false);

      return false;
    }
  }

  const validateEmailAddress = (emailAddress) => {
    if (emailAddress.match(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/)) {
      setIsValidEmailAddress(true);

      return true;
    } else {
      setIsValidEmailAddress(false);

      return false;
    }
  }
  //duallistbox
  const onChangeDualListbox = (selectedVar) => {
    var oldSelectedList = InitalSelectedList;
    var havediff = false;
    var removeMid = [];

    if (oldSelectedList.length == 0 && selectedVar.length >=0 ) {
      setSelectedList(selectedVar);
    }
    else {
      for (var i = 0; i < oldSelectedList.length; i++) {
        havediff = false;
        if (selectedVar.length == 0 && oldSelectedList.length != selectedVar.length) {
          havediff = true
        } else {
          for (var ii = 0; ii < selectedVar.length; ii++) {
            if (!havediff) {
              if (oldSelectedList[i] == selectedVar[i]) {
                havediff = false
              }
              else {
                havediff = true
              }
            }
          }
        }
        if (havediff) {
          removeMid.push(oldSelectedList[i]);
        }
        else {
          setSelectedList(selectedVar);
        }
      }

      if (removeMid.length > 0) {
        axios.get(`user/HaveNotificationRecipient?mid=${removeMid}&portaluserid=${user.portalUserId}`)
          .then(response => {
            if (response.data) {
              alert('Please remove the user as recipient for the selected MID!');
              setSelectedList(SelectedList);
            }
            else {
              setSelectedList(selectedVar);
            }
          }).catch(() => {
            console.log('Notification Recipient : There is a problem fetching the MIDs. Please try again later.');
          });
      }

    }

  }
  const getMIDProfiles = () => {
    axios.get(`user/getmids?accountId=${authSession?.merchantGroupCode}`)
      .then(response => {
        setMIDProfiles(response.data.mids);
      }).catch(() => {
        console.log('There is a problem fetching the MIDs. Please try again later.');
      });
  };
  const getMidSelected = (portalUserId) => {
    axios.get(`user/getmids?accountId=${authSession?.merchantGroupCode}&portaluserid=${portalUserId}`)
      .then(response => {
        const midarray = [];
        response.data.mids.forEach(element => {
          midarray.push(element.value);
        });
        setSelectedList(midarray);
        setinitialSelectedList(midarray);
      }).catch(() => {
        console.log('There is a problem fetching the MIDs select. Please try again later.');
      });
  };
  // end dual listbox

  var passwordRegex = (userId > 0) ? formState.values.newPassword.match(/[`~!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g) : user.password.match(/[`~!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g);
  var specialCharCount = 0;

  if (passwordRegex !== null)
    specialCharCount = parseInt(passwordRegex.length);

  return (
    <>
      <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
        <div className="page-header">
          <h1>User Details</h1>
          <h3>Create or modify a sub-user details that can log in to merchant portal.</h3>
          <p>
            <MDBIcon icon="link" className="text-green" fixed />
            <a className="text-green" href="/admin/index"> Dashboard</a> / User Management / User Details
          </p>
        </div>
        <Container>
          <Row>
            <div className="col">
              <Row>
                <Col md="12" xs="12">
                  <Card className="card-stats mb-4 mb-xl-0 shadow">
                    <CardHeader className="border-0">
                      <h3 className="mb-0">User Information</h3>
                    </CardHeader>
                    <hr className="mt--0 divider" />
                    <CardBody>
                      {
                        openAlert &&
                        (
                          <Alert className="login-error" color={formState.errorColor} isOpen={openAlert} toggle={handleAlertClose} fade={true}>
                            <i className="fa fa-exclamation-triangle icon-margin-right"></i>
                            {formState.errorMessage}
                          </Alert>
                        )
                      }

                      <h5 className="required-label">
                        <i>All fields with red asterisk ({redAsterisk()}) are required to fill.</i>
                      </h5>
                      <Row>
                        <Col>
                          <FormGroup>
                            <Label for="username">Username {redAsterisk()}</Label>
                            <Input type="input" name="username" id="username" size="md" value={user.username} disabled={!window.location.href.includes('user/add')}
                              onChange={event => handleChange(event, event.target.value, event.target.name)} />
                          </FormGroup>
                          <FormGroup>
                            <Label for="mobileNumber">Mobile Number {redAsterisk()}</Label>
                            <Input type="input" name="mobileNumber" id="mobileNumber" size="md" valid={isValidMobile} invalid={!isValidMobile}
                              value={user.mobileNumber} onChange={event => handleChange(event, event.target.value, event.target.name)} />
                            <FormText>(Format: <strong>+63</strong>xxxxxxxxxx or <strong>09</strong>xxxxxxxxx)</FormText>
                          </FormGroup>
                          <FormGroup>
                            <Label for="access">Access</Label>
                            <Input type="select" name="access" id="access" value={access} onChange={event => handleChange(event, event.target.value, event.target.name)}>
                              <option value="portal">Portal</option>
                              <option value="device">Device</option>
                              <option value="both">Both</option>
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label for="password">Password {redAsterisk()}</Label>
                            <Input type="password" name="password" id="password" size="md" value={user.password} disabled={!window.location.href.includes('user/add')}
                              onChange={event => handleChange(event, event.target.value, event.target.name)} />
                            <FormText color="muted" style={{ float: 'right' }} >
                              <Button
                                color="link"
                                style={{ padding: '0px 0px 1px' }}
                                onClick={() => handleChangePasswordClick({ value: user.portalUserId })}
                                hidden={window.location.href.includes('user/add')}>
                                <u>Change Password</u>
                              </Button>
                            </FormText>
                          </FormGroup>
                          <FormGroup>
                            <Label for="emailAddress">EmailAddress {redAsterisk()}</Label>
                            <Input type="input" name="emailAddress" id="emailAddress" size="md" valid={isValidEmailAddress} invalid={!isValidEmailAddress}
                              value={user.emailAddress} onChange={event => handleChange(event, event.target.value, event.target.name)} />
                            <FormText>(Format: username@domain.com | E.g janesmith@gmail.com)</FormText>
                          </FormGroup>
                          <FormGroup>
                            <Label for="status">Status</Label>
                            <Input type="select" name="status" id="status" value={user.status} onChange={event => handleChange(event, event.target.value, event.target.name)}>
                              <option value={1}>Active</option>
                              <option value={2}>Inactive</option>
                              <option value={3}>Locked</option>
                            </Input>
                          </FormGroup>
                        </Col>
                      </Row>

                      <hr className="mt--0 divider" />
                      <h5 className="required-label" style={{ padding: '10px 0px 0px 0px' }}>
                        <Label>MID LIST</Label>
                      </h5>
                      <Container style={{ paddingBottom: '2%' }}>
                        <Col>
                          <Row>
                            <Col>
                              <Label for="MID">Available MID :</Label>
                            </Col>

                            <Col>
                              <Label for="MID" style={{ padding: '0px 10px 0px' }}>Allowed MID :</Label>
                            </Col>
                          </Row>
                          <DualListBox
                            canFilter
                            options={midProfiles}
                            selected={SelectedList}
                            onChange={onChangeDualListbox}
                          />
                        </Col>

                      </Container>
                      <Row>
                        <Col>
                          <FormGroup>
                            <Label>Date Created: {user.dateCreated !== 'n/a' ? moment(user.dateCreated).format('YYYY-MM-DD HH:mm:ss') : user.dateCreated}</Label>
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label>Date Modified: {user.dateModified !== 'n/a' ? moment(user.dateModified).format('YYYY-MM-DD HH:mm:ss') : user.dateModified}</Label>
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label>Last Login Date: {user.lastLoginDate !== 'n/a' ? moment(user.lastLoginDate).format('YYYY-MM-DD HH:mm:ss') : user.lastLoginDate}</Label>
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label>Last Password Change: {user.lastPasswordChange !== 'n/a' ? moment(user.lastPasswordChange).format('YYYY-MM-DD HH:mm:ss') : user.lastPasswordChange}</Label>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <FormGroup>
                            <Button color="info" onClick={(event) => handleSubmit(event)}>
                              <MDBIcon icon="save" style={{ marginRight: '10px' }} />
                              SAVE CHANGES
                            </Button>
                          </FormGroup>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </div>
          </Row>
        </Container>
      </div>

      <Modal isOpen={modalPass} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal} style={changePassword}>
          <p style={{ textAlign: "center" }}>
            <Media object width="100" style={imageHeader} src={require("assets/img/brand/change_password.png")} alt="Change password" />
          </p>
          <div className="text-center mb-4" style={{ fontWeight: "500", fontSize: "20px" }}>
            Change Your Password
          </div>
          <div className="text-center text-muted mb-4" style={{ marginTop: "-20px", fontSize: "16px" }}>
            <small>It's a good idea to use a strong password that you don't use elsewhere.</small>
          </div>
          <hr className="mt--3 divider" />
        </ModalHeader>
        <ModalBody>
          <Form role="form">
            {
              openAlertModal &&
              (<Alert color={formState.errorColorModal} isOpen={openAlertModal} toggle={handleAlertClose} fade={true} style={{ marginTop: '-30px' }}>
                {formState.errorMessageModal}
              </Alert>)
            }
            <FormGroup className="mb-3 mt--3">
              <small style={{ fontWeight: 500 }}>New Password: {redAsterisk()}</small>
              <InputGroup className="input-group-alternative">
                <Input placeholder="New Password" type={formState.showNewPassword ? "text" : "password"} autoComplete={false} onChange={event => handlePasswordChange(event, event.target.value, event.target.name)} name="newPassword" value={formState.values.newPassword || ''} />
                <InputGroupText onClick={() => { handleShowPassword("newPassword") }}>
                  <MDBIcon icon={formState.showNewPassword ? "eye-slash" : "eye"} />
                </InputGroupText>
              </InputGroup>
            </FormGroup>
            <FormGroup>
              <small style={{ fontWeight: 500 }}>Confirm Password: {redAsterisk()}</small>
              <InputGroup className="input-group-alternative">
                <Input placeholder="Confirm Password" type={formState.showConfirmPassword ? "text" : "password"} autoComplete={false} onChange={event => handlePasswordChange(event, event.target.value, event.target.name)} name="confirmPassword" value={formState.values.confirmPassword || ''} required data-error="Confirm Password is required" />
                <InputGroupText onClick={() => { handleShowPassword("confirmPassword") }}>
                  <MDBIcon icon={formState.showConfirmPassword ? "eye-slash" : "eye"} />
                </InputGroupText>
              </InputGroup>
            </FormGroup>
            {passwordValidation()}
          </Form>
        </ModalBody>
        <ModalFooter>
          <div style={{ marginTop: '-40px' }}>
            <Button color="info" onClick={() => handleSubmitPassword()}
              disabled={!((formState.values.newPassword === formState.values.confirmPassword) && (formState.values.newPassword !== '') &&
                (!passwordHistory.some(x => x.password === formState.values.newPassword)) &&
                (specialCharCount >= parseInt(minSpecialCharacters)) &&
                (formState.values.newPassword.trim().length >= parseInt(minPasswordLength)))}>
              Change Password
            </Button>
            <Button color="info" onClick={toggleModal}>Close</Button>
          </div>
        </ModalFooter>
      </Modal>
    </>
  )
};

export default UserDetails;